module.exports = __webpack_public_path__ + "static/snakehips0-453836c050c16719df9614393ed2eb27.png";